import * as React from 'react';
import { Image, UIText2 } from '@cian/ui-kit';

import * as styles from './ListItem.css';

interface IListItemProps {
  defaultIcon: React.ReactNode;
  logoUrl?: string | null;
  name: string;
}

export function ListItem({ defaultIcon, logoUrl, name }: IListItemProps) {
  return (
    <div className={styles['item']}>
      <div className={styles['logo']}>
        {logoUrl ? <Image src={logoUrl} borderRadius="0" /> : <div className={styles['logo-icon']}>{defaultIcon}</div>}
      </div>
      <div className={styles['content']}>
        <UIText2>{name}</UIText2>
      </div>
    </div>
  );
}
